// Abonent kartasidan o'tish havolalari — SHARTNOMA-2 §C.
//
// ⚠️ Manzil va filtr IMLOSI bu yerda TAKRORLANMAYDI — u
// `shared/lib/pageLinks` da, agent havolalari bilan BITTA joyda.
// Ikki nusxa ajrashganda buzilish xato emas, JIMGINA noto'g'ri ro'yxat
// bo'lib ko'rinardi.

import { GRANTS_PATH, TRANSACTIONS_PATH, grantsHref, transactionsHref } from '@/shared/lib/pageLinks'

export { GRANTS_PATH, TRANSACTIONS_PATH }

/** «Paketlari» — berilgan paketlar, shu abonent bo'yicha filtrlangan */
export function subscriberGrantsHref(subscriberId: string): string {
  return grantsHref({ subscriberId })
}

/**
 * «To'lovlari» — tranzaksiyalar, `ownerType=SUBSCRIBER&ownerId=<id>`.
 *
 * ⚠️ ILGARI HAVOLA IKKI IMLODA yozilardi (prefikssiz + `f.`), chunki
 * tranzaksiyalar sahifasini qaysi birini o'qishi kelishilmagan edi.
 * Endi kelishilgan va O'LCHANGAN: `TransactionsPage` jadval holatini
 * `useTableUrlState` orqali `f.` prefiksi bilan o'qiydi, prefikssiz
 * juftlikni esa `normalizeJournalParams` KIRISHDA `f.` ga ko'chiradi va
 * manzildan O'CHIRADI. Ya'ni ikkinchi juftlik hech qachon ishlatilmasdi
 * — u faqat manzilni ikki barobar uzun qilardi.
 */
export function subscriberTransactionsHref(subscriberId: string): string {
  return transactionsHref('SUBSCRIBER', subscriberId)
}
